import React from 'react'
import CartCoupon from './CartCoupon'
import CartMenu from './CartMenu'
import CartProduct from './CartProduct'
import CartGiftCoupon from './CartGiftCoupon'
import { COUPON_TYPES } from '../../../../redux/selector/cart/constants'

const CartItem = React.memo(({
	active, item, couponDiscountInCurrency, removeAbility, onClick, onClickPlus,
	onClickMinus, onClickToppingMinus, AddButton, handleRemoveRemark, handleRemoveCoupon,
	plusBtnColor = null, orderTask = false, savedOrder,
	enabledDishCourse = false, onClickProduct = () => {
	}, disabled, onClickInfo, onClickBack, onClickBackTopping, module, onClickToppingInfo,
}) => {

	return (
		item?.type === 'MENU' ?
			<CartMenu active={active}
								item={item}
								savedOrder={savedOrder}
								removeAbility={removeAbility}
								AddButton={AddButton}
								onClick={onClick}
								onClickPlus={onClickPlus}
								onClickMinus={onClickMinus}
								onClickInfo={onClickInfo}
								onClickBack={onClickBack}
								handleRemoveRemark={handleRemoveRemark}
								enabledDishCourse={enabledDishCourse}
								onClickProduct={onClickProduct}
								onClickBackTopping={onClickBackTopping}
								onClickToppingInfo={onClickToppingInfo}
								disabled={disabled}
								module={module} /> :
			COUPON_TYPES.includes(item?.type) ?
				<CartCoupon coupon={item}
										active={active}
										handleRemoveCoupon={handleRemoveCoupon}
										enabledDishCourse={enabledDishCourse}
				/> :
				item?.type === 'GIFT_COUPON' ?
					<CartGiftCoupon coupon={item}
													onClickMinus={onClickMinus}
													AddButton={AddButton}
													onClickPlus={onClickPlus}
													onClickInfo={onClickInfo}
													onClickBack={onClickBack}
													enabledDishCourse={enabledDishCourse}
													module={module} /> :
					<CartProduct active={active}
											 item={item}
											 savedOrder={savedOrder}
											 removeAbility={removeAbility}
											 orderTask={orderTask}
											 AddButton={AddButton}
											 onClick={onClick}
											 onClickPlus={onClickPlus}
											 onClickMinus={onClickMinus}
											 onClickInfo={onClickInfo}
											 onClickBack={onClickBack}
											 onClickBackTopping={onClickBackTopping}
											 onClickToppingInfo={onClickToppingInfo}
											 onClickToppingMinus={onClickToppingMinus}
											 handleRemoveRemark={handleRemoveRemark}
											 plusBtnColor={plusBtnColor}
											 enabledDishCourse={enabledDishCourse}
											 onClickProduct={onClickProduct}
											 incrementAbility={!['CASH_EXCHANGE', 'EXTRA_DISCOUNT'].includes(item?.type)}
											 disabled={disabled}
											 module={module} />
	)
})

CartItem.displayName = 'CartItem'
export default CartItem
